//
import "../PagesCss/Default.css";
import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import { Geste_Instance, Auth_Instance } from "../services/services";
import Swal from "sweetalert2";
const showNotice = async (language, username) => {
  let currentHTML = `
        <div style="background-color: #fcfdfe;">
            <div class="">
              <strong class="notice-title" style="color:green" > INFORMATION REQUEST</strong>
          
                 <p class="mb-2">
            Please provide your business email for future password recovery/reset.
              </p>
              <p class="mb-2">
              If this is a shared account, please enter the location email and            contact us at     <a href="mailto:info@progressiveestatesolutions.com">
                  info@progressiveestatesolutions.com
                </a>
              </p>
<div style="display:flex; align-items:center; gap:10px; margin-top:15px;">
  
  <label 
    for="swal-username"
    style="min-width:90px; font-size:13px; font-weight:600; color:#555;"
  >
    Username
  </label>

  <input
    id="swal-username"
    type="text"
    value="${username || ""}"
    disabled
    style="
      flex:1;
      padding:8px 10px;
      font-size:14px;
      border:1px solid #dcdcdc;
      border-radius:6px;
      background-color:#f5f7fa;
      color:#555;
      outline:none;
      cursor:not-allowed;
    "
  />

</div>
<div style="display:flex; align-items:center; gap:10px; margin-top:10px;">
  
  <label 
    for="swal-email"
    style="min-width:90px; font-size:13px; font-weight:600; color:#555;"
  >
    Email
  </label>

  <input
    id="swal-email"
    type="email"
    placeholder="Enter Email"
    value=""
    required
    style="
      flex:1;
      padding:8px 10px;
      font-size:14px;
      border:1px solid #dcdcdc;
      border-radius:6px;
      background-color:#fff;
      color:#333;
      outline:none;
    "
  />

</div>
            </div>
          </div> 
    `;
  if (language === "french") {
    currentHTML = `
        <div style="background-color: #fcfdfe;">
            <div class="">
              <strong class="notice-title" >ATTENTION</strong>
                           <p class="mb-2">
          veuillez indiquer le courriel de l’entreprise qui est associé à ce compte.
              </p>
              <p class="mb-2">
               Si celui-ci est un compte partagé veuillez nous contacter à l’adresse suivante;
                <a href="mailto:info@progressiveestatesolutions.com">
                  info@progressiveestatesolutions.com
                </a>
              </p>
       <div style="display:flex; align-items:center; gap:10px; margin-top:15px;">
  
  <label 
    for="swal-username"
    style="min-width:90px; font-size:13px; font-weight:600; color:#555;"
  >
    Username
  </label>

  <input
    id="swal-username"
    type="text"
    value="${username || ""}"
    disabled
    style="
      flex:1;
      padding:8px 10px;
      font-size:14px;
      border:1px solid #dcdcdc;
      border-radius:6px;
      background-color:#f5f7fa;
      color:#555;
      outline:none;
      cursor:not-allowed;
    "
  />

</div>
<div style="display:flex; align-items:center; gap:10px; margin-top:10px;">
  
  <label 
    for="swal-email"
    style="min-width:90px; font-size:13px; font-weight:600; color:#555;"
  >
    Email
  </label>

  <input
    id="swal-email"
    type="email"
    placeholder=""
    value=""
    required
    style="
      flex:1;
      padding:8px 10px;
      font-size:14px;
      border:1px solid #dcdcdc;
      border-radius:6px;
      background-color:#fff;
      color:#333;
      outline:none;
    "
  />

</div>
            </div>
          </div> 
    `;
  }
  const result = await Swal.fire({
    html: currentHTML,
    confirmButtonText: "Submit",
    confirmButtonColor: "#3085d6",

    preConfirm: async () => {
      const email = document.getElementById("swal-email").value;

      if (!email) {
        Swal.showValidationMessage("Email is required");
        return false;
      }

      try {
        const response = await Auth_Instance.post(`/api/add_email/`, {
          email: email,
          username: username,
        });

        if (response?.status === 200) {
          NotificationManager.success(response?.data?.msg);
          return true;
        }
      } catch (error) {
        console.log(error?.response?.data);
        NotificationManager.error(
          error?.response?.data?.ATTENTION || "Failed to add email",
        );

        return false;
      }
    },
  });

  return result;
};

const Login = () => {
  const [expanded, setExpanded] = useState(false);
  const noticeText =
    "Website notice:  Please try Microsoft Edge if you encounter difficulties - we are investigating a few reports of random issues with Chrome. Please also let us know Website@progressiveestatesolutions.com. We appreciate your assistance and apologize for any inconvenience!";
  // const navigate = useNavigate();
  useEffect(() => {
    if (!localStorage.getItem("Updateanotherlogin")) {
      localStorage.clear();
      if ("caches" in window) {
        caches
          .keys()
          .then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          })
          .then(() => {
            // window.location.reload(true);
          });
      }
    }
  }, []);
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [id]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      localStorage.setItem("userNameForEmail", formData?.username);
      const response = await Geste_Instance.post(`/api/login/`, formData);
      if (
        response.data.RoutingID == 200 ||
        response.data.RoutingID == 123 ||
        response.data.RoutingID == 210
      ) {
        window.location = "https://executorsaide.com/dignityInput";
        return;
      }
      if (!localStorage.getItem("Updateanotherlogin")) {
        localStorage.setItem("userData", JSON.stringify(response.data));
        localStorage.setItem("jwt", JSON.stringify(response.data.jwt));
        localStorage.setItem(
          "csrfToken",
          JSON.stringify(response.data.csrfToken),
        );
      }
      if (response?.data?.redirect) {
        if (response?.data?.redirect === "add-email-english") {
          const result = await showNotice("english", formData?.username);
          if (result.isConfirmed) {
            setTimeout(() => {
              window.location = "/thankyou";
            }, 3000);
          }
        }

        if (response?.data?.redirect === "add-email-french") {
          window.location = "/dignityInput";
        }
      } else {
        window.location = "/dignityInput";
      }
    } catch (error) {
      console.error(
        "Error occurred while logging in2",
        error,
        error?.response?.data?.msg,
      );
      if (error?.response?.data?.redirect) {
        NotificationManager.error(error?.response?.data?.ATTENTION);
        if (error?.response?.data?.redirect === "add-email") {
          setTimeout(() => {
            window.location = "/addemail";
          }, 4000);
        }
        return;
      }
      if (error?.response?.data?.msg) {
        NotificationManager.error(error?.response?.data?.msg);
        if (
          error?.response?.data?.msg?.includes("90 days") ||
          error?.response?.data?.msg?.includes("90 jours")
          // &&
          // response.data.RoutingID != 101
        ) {
          setTimeout(() => {
            window.location = "/PasswordRecovery";
          }, 5000);
        }
      } else {
        NotificationManager.error(`Login Failed !! Contact Administrator `);
      }
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <>
      <div className="loginContainer">
        <div className="row justify-content-center loginCentre">
          <div className="col-lg-5">
            {/* Basic login form*/}
            <div
              className="card shadow-lg border-0 rounded-lg "
              style={{ backgroundColor: "#fff" }}
            >
              <div
                className="card-header justify-content-center"
                style={{ textAlign: "center" }}
              >
                {/* <img
                        src={logo}
                        alt="logo"
                        style={{
                          width: "20rem",
                          height: "15rem",
                          marginTop: "-85px",
                          objectFit: "cover",
                          left: "-10%",
                          position: "relative",
                        }}
                      /> */}
                <h3
                  className="fw-bold"
                  style={{
                    fontSize: "25px",
                    marginTop: "5px",
                    marginBottom: "10px",
                  }}
                >
                  Login
                </h3>
              </div>

              <div className="card-body">
                {/* Login form*/}
                <form onSubmit={handleSubmit}>
                  {/* Form Group (email address) */}
                  <div className="mb-3">
                    <label className="small mb-1" htmlFor="username">
                      Username
                    </label>
                    <input
                      className="form-control"
                      id="username"
                      type="text"
                      placeholder="Enter username"
                      value={formData.username}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  {/* Form Group (password) */}
                  <div className="mb-3">
                    <label className="small mb-1" htmlFor="password">
                      Password
                    </label>
                    <input
                      className="form-control"
                      id="password"
                      type="password"
                      placeholder="Enter password"
                      value={formData.password}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="d-flex justify-content-center mt-4 mb-0">
                    <button
                      type="submit"
                      id="loginBtnId"
                      className="btn btn-primary"
                    >
                      Login
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div className="notice-container">
            <div className="alert alert-light shadow-sm website-notice">
              <strong className="notice-title">Website Notice:</strong>
              <p className="mb-2">
                Please try <strong>Microsoft Edge</strong> if you encounter
                difficulties – we are investigating a few reports of random
                issues with Chrome.
              </p>
              <p className="mb-2">
                Please also let us know{" "}
                <a href="mailto:info@progressiveestatesolutions.com">
                  info@progressiveestatesolutions.com
                </a>
              </p>
              <p className="mb-0">
                We appreciate your assistance and apologize for any
                inconvenience!
              </p>
            </div>
          </div>
          <footer className="footer-admin mt-auto footer-light">
            <div className="container-xl px-4">
              <div className="row" style={{ marginTop: "27%" }}>
                <div className="col-md-6 small">
                  Copyright © Progressive Estate Solutions Inc. {currentYear}
                </div>
                <div className="col-md-6 text-md-end small">
                  {" "}
                  <a
                    className="col-md-6 text-md-end small"
                    href="/PrivacyStatement"
                  >
                    Privacy Statement
                  </a>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </>
  );
};

export default Login;
